"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var FormattingConstants = {
    REGEX_LICENSEPLATE_FORMATTER: [/^([A-Z]{2})\-?([\d]{2})\-?([\d]{2})$/i, // 1   XX-99-99
    /^([\d]{2})\-?([\d]{2})\-?([A-Z]{2})$/i, // 2   99-99-XX
    /^([\d]{2})\-?([A-Z]{2})\-?([\d]{2})$/i, // 3   99-XX-99
    /^([A-Z]{2})\-?([\d]{2})\-?([A-Z]{2})$/i, // 4   XX-99-XX
    /^([A-Z]{2})\-?([A-Z]{2})\-?([\d]{2})$/i, // 5   XX-XX-99
    /^([\d]{2})\-?([A-Z]{2})\-?([A-Z]{2})$/i, // 6   99-XX-XX
    /^([\d]{2})\-?([A-Z]{3})\-?([\d]{1})$/i, // 7   99-XXX-9
    /^([\d]{1})\-?([A-Z]{3})\-?([\d]{2})$/i, // 8   9-XXX-99
    /^([A-Z]{2})\-?([\d]{3})\-?([A-Z]{1})$/i, // 9   XX-999-X
    /^([A-Z]{1})\-?([\d]{3})\-?([A-Z]{2})$/i, // 10  X-999-XX
    /^([A-Z]{3})\-?([\d]{2})\-?([A-Z]{1})$/i, // 11  XXX-99-X
    /^([A-Z]{1})\-?([\d]{2})\-?([A-Z]{3})$/i, // 12  X-99-XXX
    /^([\d]{1})\-?([A-Z]{2})\-?([\d]{3})$/i, // 13  9-XX-999
    /^([\d]{3})\-?([A-Z]{2})\-?([\d]{1})$/i // 14  999-XX-9
    ]
};

exports.default = FormattingConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/formatting/formatting.constants.js
// module id = 783
// module chunks = 0